module.exports = __webpack_public_path__ + "img/jumbopackh2h-active.46286ef5.svg";